/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnPricing.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnPricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isCompareExpanded: true,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleToggleComparison = this.handleToggleComparison.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  handleToggleComparison() {
    this.setState((prevState) => ({
      isCompareExpanded: !prevState.isCompareExpanded,
    }));
  }
  render() {
    const { isCompareExpanded } = this.state;
    const capitalizeFirstLetter = (string) => {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const PlanText = [
      {
        name: "free",
        price: "$0.00",
        description: (
          <>
            Free for all
            <br />
            charitable organizations
            <br />
            registered in Hong Kong
          </>
        ),
        access: true,
        web: true,
        receipt: true,
        report: false,
        number: true,
        numberNote: "Quick Payment only",
        campaignDetails: null,
        creditCard: true,
        applePay: false,
        googlePay: false,
        recurringTransactions: false,
        PayMe: false,
        multipleLanguages: false,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: false,
        reducedTransactionFee: false,
        platformFee: "2%",
        manualPayments: false,
        customDomain: false,
        customInputFields: false,
        bgColor: "#93C7EA",
        txtColor: "#93C7EA",
      },
      {
        name: "plus",
        price: (
          <>
            $459/month
            <br />
            <span style={{ fontSize: "12px", fontWeight: "400" }}>
              per month billed annually
            </span>
          </>
        ),
        description: "or $550/month billed monthly",
        access: true,
        web: true,
        receipt: true,
        report: true,
        number: true,
        numberNote: "Up to 3",
        campaignDetails: "Up to 3 payment items or donation campaigns",
        creditCard: true,
        applePay: false,
        googlePay: false,
        recurringTransactions: false,
        PayMe: false,
        multipleLanguages: false,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: true,
        reducedTransactionFee: true,
        platformFee: "1%",
        manualPayments: false,
        customDomain: false,
        customInputFields: false,
        bgColor: "#1390E3",
        txtColor: "#1390E3",
      },
      {
        name: "pro",
        price: (
          <>
            $792/month
            <br />
            <span style={{ fontSize: "12px", fontWeight: "400" }}>
              per month billed annually
            </span>
          </>
        ),
        description: "or $950/month billed monthly",
        access: true,
        web: true,
        receipt: true,
        report: true,
        number: true,
        numberNote: "Up to 5",
        campaignDetails: "Up to 5 payment items or donation campaigns",
        creditCard: true,
        applePay: true,
        googlePay: true,
        recurringTransactions: true,
        PayMe: true,
        multipleLanguages: true,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: true,
        reducedTransactionFee: true,
        platformFee: "1%",
        manualPayments: false,
        customDomain: false,
        customInputFields: false,
        bgColor: "#0969AA",
        txtColor: "#0969AA",
      },
      {
        name: "premium",
        price: (
          <>
            $1,250/month
            <br />
            <span style={{ fontSize: "12px", fontWeight: "400" }}>
              per month billed annually
            </span>
          </>
        ),
        description: "or $1,500/month billed monthly",
        access: true,
        web: true,
        receipt: true,
        report: true,
        number: true,
        numberNote: "Unlimited",
        campaignDetails: "Unlimited payment items and donation campaigns",
        creditCard: true,
        applePay: true,
        googlePay: true,
        recurringTransactions: true,
        PayMe: true,
        multipleLanguages: true,
        verifiedNonprofit: true,
        coverFees: true,
        landingPageCustomization: true,
        reducedTransactionFee: true,
        platformFee: "1% or 0.5%*",
        manualPayments: true,
        customDomain: true,
        customInputFields: true,
        bgColor: "linear-gradient(45deg, rgba(162,248,255,1) 0%, rgba(0,88,149,1) 100%)",
        txtColor: "#52A9CB",
      }
    ];

    const PLATFORM_FEE_DISCLAIMER = "*If transaction volume exceeds over $400k in the past 12 months";

    const featureCellStyle = {
      display: "flex",
      height: "75px",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    };

    const featureLabelItemStyle = {
      height: "75px",
      justifyContent: "end",
      alignItems: "center",
      color: "black",
      textAlign: "left",
      fontSize: "10pt",
    };

    const renderCheckIcon = (enabled) => (
      enabled ? (
        <div className="EnPricing-confirmFeature" alt="Confirm" />
      ) : (
        <div className="EnPricing-crossFeature" alt="Cross" />
      )
    );

    const compareRows = [
      {
        key: "plans",
        label: "Plans",
        render: (plan) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div
              className="EnPricing-planDot"
              style={{
                background: plan.bgColor,
              }}
            />
            <div
              className="EnPricing-planTxt"
              style={{
                color: plan.txtColor,
                fontWeight: "600",
              }}
            >
              {capitalizeFirstLetter(plan.name)}
            </div>
          </div>
        ),
      },
      {
        key: "verified-nonprofit",
        label: "Included in the verified Nonprofit list on CheckPlus (Stay tuned for more exclusive offers!)",
        render: (plan) => renderCheckIcon(plan.verifiedNonprofit),
      },
      {
        key: "org-dashboard",
        label: "Access to Organization Dashboard",
        render: (plan) => renderCheckIcon(plan.access),
      },
      {
        key: "items",
        label: "Number of Items/Projects/Campaigns",
        render: (plan) =>
          plan.number ? (
            <div className="EnPricing-numberNote">{plan.numberNote}</div>
          ) : (
            renderCheckIcon(false)
          ),
      },
      {
        key: "automated-receipts",
        label: "Automated Payment and Donation Receipt Sending",
        render: (plan) => renderCheckIcon(plan.receipt),
      },
      {
        key: "cover-fees",
        label: "Cover Fees: Donors can choose to Cover Transaction Fee for Nonprofits",
        render: (plan) => renderCheckIcon(plan.coverFees),
      },
      {
        key: "landing-page",
        label: "Create a Payment Landing Page",
        render: (plan) => renderCheckIcon(plan.web),
      },
      {
        key: "landing-customisation",
        label: "Payment Landing Page Customisation",
        render: (plan) => renderCheckIcon(plan.landingPageCustomization),
      },
      {
        key: "system-report",
        label: "System Report Generation",
        render: (plan) => renderCheckIcon(plan.report),
      },
      {
        key: "multiple-languages",
        label: "Multiple Languages",
        render: (plan) => renderCheckIcon(plan.multipleLanguages),
      },
      {
        key: "recurring",
        label: "Monthly Recurring Transactions",
        render: (plan) => renderCheckIcon(plan.recurringTransactions),
      },
      {
        key: "manual-payments",
        label: "Manual Payments (e.g. Cheques, Octopus, Cash, etc.)",
        render: (plan) => renderCheckIcon(plan.manualPayments),
      },
      {
        key: "custom-domains",
        label: "Custom Domains",
        render: (plan) => renderCheckIcon(plan.customDomain),
      },
      {
        key: "custom-inputs",
        label: "Custom Input Fields",
        render: (plan) => renderCheckIcon(plan.customInputFields),
      },
      {
        key: "payment-methods",
        label: "Payment Methods",
        isSectionHeader: true,
        render: () => null,
      },
      {
        key: "credit-card",
        label: "Credit Card (Via Stripe) Visa, MasterCard, AMEX, UnionPay",
        render: (plan) => renderCheckIcon(plan.creditCard),
      },
      {
        key: "reduced-card-fee",
        label: "Reduced Transaction Fee for Credit Card Transactions",
        render: (plan) => renderCheckIcon(plan.reducedTransactionFee),
      },
      {
        key: "apple-pay",
        label: "Apple Pay",
        render: (plan) => renderCheckIcon(plan.applePay),
      },
      {
        key: "google-pay",
        label: "Google Pay",
        render: (plan) => renderCheckIcon(plan.googlePay),
      },
      {
        key: "payme",
        label: "PayMe",
        render: (plan) => renderCheckIcon(plan.PayMe),
      },
      {
        key: "platform-fee",
        label: "Platform Fee",
        render: (plan) =>
          plan.platformFee ? (
            <div className="EnPricing-numberNote" style={{ textAlign: "center" }}>
              {plan.platformFee}
            </div>
          ) : (
            renderCheckIcon(false)
          ),
      },
    ];

    const renderPlanCell = (row, plan) =>
      row.isSectionHeader ? null : row.render(plan);

    const renderComparisonTable = (plans) => (
      <div className="EnPricing-featureContainer2">
        <div className="EnPricing-featureSet">
          {compareRows.map((row) => (
            <div
              style={{
                ...featureLabelItemStyle,
                fontWeight: row.isSectionHeader ? "600" : undefined,
              }}
              key={row.key}
            >
              <div
                className="EnPricing-featureText"
                style={row.isSectionHeader ? { textTransform: "uppercase" } : {}}
              >
                {row.label}
              </div>
            </div>
          ))}
        </div>

        {plans.map((plan, index) => (
          <div key={`${plan.name}-${index}`}>
            <div className="EnPricing-featureDescriptionRowBottom">
              {compareRows.map((row) => (
                <div style={featureCellStyle} key={row.key}>
                  {renderPlanCell(row, plan)}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
    return (
      <div className="EnPricing-view">
        <Helmet>
          <title>Pricing - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="EnPricing-first">
          <div className="EnPricing-mainContainer">
            <div className="EnPricing-topContainer">
              <div className="EnPricing-heading">
                Make your nonprofit more efficient, 
                <br />
                so that you can do more.
              </div>

              <div className="EnPricing-comingSoon">
                <div className="EnPricing-comingText">New subscription plans</div>
              </div>
            </div>

            <div className="EnPricing-featureContainer">
              <div className="EnPricing-extraSpace"></div>

              {PlanText.map((plan, key) => (
                <div
                  className="EnPricing-featureDescriptionColumn"
                  key={key}
                  style={{ position: "relative", minHeight: "600px", paddingBottom: "200px", marginTop: "30px",marginBottom: "30px" }}
                >
                  <div
                    className="EnPricing-featureDescriptionRowTop"
                    style={{
                      background: plan.bgColor,
                    }}
                  >
                    <div className="EnPricing-planContainer">
                      <div className="EnPricing-planName">{capitalizeFirstLetter(plan.name)}</div>

                      <div className="EnPricing-planPrice">{plan.price}</div>

                      <div className="EnPricing-planDescription">
                        {plan.description}
                      </div>
                    </div>
                  </div>
                  <div className="EnPricing-featureContainerRowBottom">
                    <Link to="/OrgSignup">
                      <div
                        className="EnPricing-getStarted"
                        style={{
                          background: plan.bgColor,
                        }}
                      >
                        Get Started
                      </div>
                    </Link>

                    {plan.name === "plus" ? (
                      <div className="EnPricing-everythingPlus">
                        Everything "Free" offers and plus the followings,
                      </div>
                    ) : null}

                    {plan.name === "pro" ? (
                      <div className="EnPricing-everythingPlus">
                        Everything "Plus" offers and plus the followings,
                      </div>
                    ) : null}

                    {plan.name === "premium" ? (
                      <div className="EnPricing-everythingPlus">
                        Everything Pro offers and plus the followings,
                      </div>
                    ) : null}

                    {plan.name === "free" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          Create an online account
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          Create a payment landing website
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          Accept payments and donations
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          Automated Payment and Donation Receipt Sending
                        </div>
                      </div>
                    ) : null}

                    {plan.name === "free" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          Accept the following payment methods powered by Stripe
                          <p />

                          <strong>Major Card Networks</strong>
                          <br />

                          - Visa
                          <br />
                          - MasterCard
                          <br />
                          - American Express
                          <br />
                          - UnionPay
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "free" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          Cover Fees: Donors can choose to Cover Transaction Fee for Nonprofits
                        </div>
                      </div>
                    ) : null}

                    {plan.campaignDetails ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          {plan.campaignDetails}
                        </div>
                      </div>
                    ) : null}

                    {plan.report && plan.name === "plus" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          Generate a system report
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "plus" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          Payment Landing Page Customisation
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.name === "plus" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">
                          Reduced Platform Fee
                        </div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.applePay && plan.name !== "premium" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">Apple Pay</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.googlePay && plan.name !== "premium" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">Google Pay</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.recurringTransactions && plan.name !== "premium" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">Monthly Recurring Transactions</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.PayMe && plan.name !== "premium" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">PayMe for Business</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.multipleLanguages && plan.name !== "premium" ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">Multiple Languages</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.customDomain ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">Custom Domain</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.manualPayments ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">Manual Payments (No platform and processing fee)</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    {plan.customInputFields ? (
                      <div className="EnPricing-paymeFeature">
                        <div
                          className="EnPricing-featureTick"
                          alt="Confirm"
                        />
                        <div className="EnPricing-featureTxt">Custom Input Fields</div>
                      </div>
                    ) : (
                      <div />
                    )}

                    <div
                      style={{
                        background: "white",
                        border: `2px solid ${plan.txtColor}`,
                        borderRadius: "15px",
                        padding: "20px",
                        textAlign: "center",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                        width: "300px",
                        boxSizing: "border-box",
                        position: "absolute",
                        top: "740px",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "14pt",
                          fontWeight: "600",
                          color: "#333",
                          marginBottom: "8px",
                        }}
                      >
                        Platform Fee
                      </div>
                      <div
                        style={{
                          fontSize: "18pt",
                          fontWeight: "700",
                          color: plan.txtColor,
                        }}
                      >
                        {plan.platformFee}
                      </div>

                      {plan.name === "premium" ? (
                        <div
                          style={{
                            marginTop: "12px",
                            fontSize: "10pt",
                            fontWeight: "400",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          {PLATFORM_FEE_DISCLAIMER}
                        </div>
                      ) : null}

                      <div
                        style={{
                          marginTop: "15px",
                          paddingTop: "15px",
                          borderTop: "1px solid #e0e0e0",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "12pt",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "5px",
                          }}
                        >
                          Processing Fee:
                        </div>
                        <div
                          style={{
                            fontSize: "11pt",
                            fontWeight: "400",
                            color: "#666",
                            fontStyle: "italic",
                          }}
                        >
                          Charged by Payment Gateway
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="EnPricing-extraSpace"></div>
            </div>

            <div className="EnPricing-topColumnRight"></div>

            <button
              type="button"
              className="EnPricing-compareButton"
              onClick={this.handleToggleComparison}
            >
              {isCompareExpanded ? "Hide Comparison" : "Compare All Plans"}
            </button>

            {isCompareExpanded && (
              <>
                {renderComparisonTable(PlanText)}

                <div
                  style={{
                    marginTop: "0px",
                    fontSize: "10pt",
                    color: "#666",
                    fontStyle: "italic",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: "50px",
                  }}
                >
                  {PLATFORM_FEE_DISCLAIMER}
                </div>
              </>
            )}

            <div className="EnPricing-TransactionFeeContainer">
              <h1>Processing Fee</h1>
            </div>

            <div className="EnPricing-gridBGTransactionFee">

        
              <div className="EnPricing-stripePaidContainer">
                <div className="EnPricing-hsbc">
                  <div className="EnPricing-stripeLogo" />
                  <div className="EnPricing-bar" />
                  <div className="EnPricing-hsbcDescription">Processing fee</div>
                </div>

                <div className="EnPricing-hsbcText">
                  <strong>Domestic Visa/Mastercard</strong>
                  <br />
                  2.9% + HK$2.35

                  <p />
                  <strong>Domestic American Express</strong>
                  <br />
                  3.4% + HK$2.35
                  <p />
                  <strong>All International Cards</strong>
                  <br />
                  + 0.5% for international cards
                </div>
              </div>
              <div className="EnPricing-hsbcContainer">
                <div className="EnPricing-hsbc">
                  <div className="EnPricing-hsbcLogo" />
                  <div className="EnPricing-bar" />
                  <div className="EnPricing-hsbcDescription">Processing Fee</div>
                </div>

                <div className="EnPricing-hsbcText">
                  <strong>PayMe for Business</strong>
                  <br />
                  1.5%
                  <br />
                  Determined by HSBC HK
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="EnPricing-referralContainer">
          <div className="EnPricing-referralWidth">
            <div className="EnPricing-heading">
              Referral Program
            </div>

            <div className="EnPricing-comingSoon">
              <div className="EnPricing-comingText">Coming Soon</div>
            </div>

            <div className="EnPricing-subHeading">
              Refer 1 and get 1 month free per successful referral*
              <p />
              <div className="EnPricing-subtitle">
                *Please note you can only get a month free when the nonprofit
                you have referred signs up for the service. There is no limit to
                the number of referral you make.
              </div>
            </div>
          </div>
        </div>

        <div className="EnPricing-footer">
          <div className="EnPricing-footerNav">
            <Link to="/EnTeam">
              <div className="EnPricing-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnPricing-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnPricing-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="EnPricing-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="EnPricing-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnPricing;
